import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminCampaignsKeys } from "Api/Queries/Admin/useAdminCampaignsQuery";
import {
  type CampaignImageType,
  deleteAdminCampaignsIdImagesImageType,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  campaignId: number;
  imageType: CampaignImageType;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteCampaignImageMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ campaignId, imageType }: Parameters) =>
        deleteAdminCampaignsIdImagesImageType(campaignId, imageType),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminCampaignsKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
